<template>
	<div id="email-detail" class="container panel" v-tooltip-container>
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head :title="name" subtitle="Password Security Portal"></dash-head>		

				<hr class="mt-3">

				<error :error="error"></error>

				<div class="row mt-3">
					<div class="col-md-12">
						<chart type="line"  @chart-complete="chartComplete"
								:width="200" 
								:height="50" 
								:responsive="true"
								:useBlank="false"				
								:values="chartValues"
								:backgroundColors="['rgba(153, 102, 255, 0.2)']"
								:borderColors="['rgba(153, 102, 255, 1)']">
						</chart>
					</div>
				</div>

					<div class="clearfix mt-1 mb-3">
					<div class="float-left ml-3">
					</div>
					<div class="float-right mr-3">
						<a class="btn btn-outline-primary px-3" :download="name + ' chart.png'" :disabled="chartBase64==null" :href="chartBase64">Export</a>								
					</div>
				</div>

				<div class="hr-divider mt-3 mb-3">
  					<h3 class="hr-divider-content hr-divider-heading"><!--Domain Details--></h3>
				</div>

				<div v-if="!showBreachDetails && !showEditEmail" class="row mt-3">
  					<div class="col-md-6">
						  <dl>
								<dt>Email</dt>
								<dd>{{name}}</dd>

								<dt v-if="isDomainRoute">User Name</dt>
								<dd v-if="isDomainRoute">{{userName}}</dd>

								<dt v-if="isDomainRoute">User Status</dt>
								<dd v-if="isDomainRoute">{{userStatusDescription}}</dd>
							</dl>
					</div>
					<div class="col-md-6">
						  <dl>
								<dt>Credentials</dt>
								<dd>{{email.passwords && email.passwords.length}}</dd>

								<dt>Total Score</dt>
								<dd>{{email.score}}</dd>

							</dl>
							<div class="text-right">
								<button class="btn btn-outline-primary px-3" @click.prevent="showHideEditEmail(true)">Edit Details</button>
							</div>
					</div>
				</div>

				<div class="row mt-3" v-if="showEditEmail">
					<div class="col-md-12">
						<edit-email-detail-form :name='name' :email='this.email' @close-edit-email="showHideEditEmail(false)"></edit-email-detail-form>
					</div>
				</div>

				<div v-if="email.score && !showBreachDetails" class="mt-3">
					<div class="row mt-3">
						<div class="col-md-6 mb-5">
							<list-group  class="mb-3" heading="Breached Credentials">
								<list-group-item 
									v-for="item in passwordsWithCount" 
									:key="item.key" 
									:description="item.password" 
									:detail="item.count"
									@item-click="itemClick">
								</list-group-item>
							</list-group>
						</div>
			
						<div class="col-md-6 mb-5">
							<list-group  class="mb-3" heading="Shared Emails">
								<list-group-item 
									v-for="result in emails" 
									:key="result" 
									:description="result"
									@item-click="itemClick">
								</list-group-item>
							</list-group>
						</div>
					</div>
					<div class="text-right">
						<a v-if="isDomainRoute" :href="'/domain/' + domainName" class="btn btn-outline-primary px-3" @click.prevent="viewDomain(domainName)">View Domain</a>
						<button class="btn btn-outline-primary px-3" @click.prevent="showHideBreachDetails(true)">Show Details</button>
					</div>
				</div>

				<div v-if="email.score && showBreachDetails" class="mt-3">

					<table-actions hideSearch="true" hideEdit="true" :deleteEnabled="checkedRows.length > 0" @delete-click="deleteClicked"></table-actions>
					<table-view id="email-breaches">
						<table-row slot="header">
							<table-header></table-header>
							<table-header class="headerSortDown2">Email</table-header>
							<table-header>Password</table-header>
							<table-header>Source</table-header>
							<table-header>Type</table-header>
						</table-row>
						<table-row slot="body" v-for="breach in breaches" :key="breach.index" >
							<table-cell><input :value="breach.index" type="checkbox" class="select-row" v-model="checkedRows"></table-cell>
							<table-cell>{{breach.email}}</table-cell>
							<table-cell><password-link :password="breach.password" :fullPassword="breach.fullPassword"></password-link></table-cell>
							<table-cell><source-tooltip v-for="source in breach.source" :key="source" :source="source"></source-tooltip></table-cell>
							<table-cell>{{breach.indirect ? 'Shared': 'Domain' }}</table-cell>
						</table-row>
					</table-view>

					<div class="row">
						<div class="col-sm-6">
							<button v-if="hasReset" class="btn btn-outline-primary px-3" @click="reset">Reset</button>
							<button class="btn btn-outline-primary px-3" @click="selectAll">Select All</button>
						</div>
						<div class="col-sm-6 text-right">
							<button class="btn btn-outline-primary px-3" @click="showHideBreachDetails(false)">Hide Details</button>
						</div>
					</div>
				
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import ListGroup from './ListGroup'
	import ListGroupItem from './ListGroupItem'
	import Chart from './Chart'
	import EditEmailDetailForm from './EditEmailDetailForm'
	import TableActions from './TableActions'
	import TableView from './TableView'
	import TableRow from './TableRow'
	import TableHeader from './TableHeader'
	import TableCell from './TableCell'
	import PasswordLink from './PasswordLink'
	import SourceTooltip from './SourceTooltip'
	import Error from './Error'

	import api from '../api'
	import router from '../router'
	import store from '../state'

	export default {
		name: 'EmailDetailPanel',
		components: {SideBar, DashHead, ListGroup, ListGroupItem, Chart, EditEmailDetailForm, TableActions, TableView, TableRow, TableHeader, TableCell, PasswordLink, SourceTooltip, Error},
		data() {
			return {
				email:{
					passwords:[]
				},
				showEditEmail: false,
				showBreachDetails: false,
				error: null,
				topRisks: [],
				checkedRows: [],
				chartBase64: null
			}
		},
		methods: {
			showHideEditEmail(value) {
				this.showEditEmail = value;
			},
			showHideBreachDetails(value) {
				this.showBreachDetails = value;
			},
			viewDomain(value)
			{
				router.push('/domain/' + value);
			},
			itemClick(value) {
				this.showHideBreachDetails(true);
			},
			async deleteClicked(value)
			{						
				try
				{
					const passwordIndexes = [];

					for (let row of this.checkedRows) {					
						const index = Math.floor(row / 1000) - 1;
						const index2 = Math.floor(row - (index + 1) * 1000);
						const item = this.email.emails[index][index2];					

						//Check if this is a linked item, or not, and call appropriate api
						const indirect = (item !== this.name);

						if (indirect) {
							await api.delete(`/email/${this.name}/linked/${item}`);	
						}
						else {
							passwordIndexes.push(index);
						}					
					}

					//Delete password indexes
					if (passwordIndexes.length) await api.delete(`/email/${this.name}/password/${passwordIndexes.join(',')}`);	

					await this.getData();
				}
				catch(err) {				
					this.error = err;
				}
			},
			async getData() {
				const name = router.currentRoute.params.name
				
				try
				{			
					const response = await api.get(`domain/email/${name}`);	
					this.email = response.data;

					this.showHideEditEmail(router.currentRoute.path.endsWith('edit'));
		
					//This should probably move to vuex and become a computed property
					if (this.isDomainRoute) {
						const response = await api.get(`domain/${this.domainName}/top`);	

						//We have a tuple returned from the .net api, so breaches is item1 and risks is item2
						this.topRisks = response.data.item2;
					}
				}
				catch(err) {
					this.error = err;
				}
			},
			chartComplete(value) {
				this.chartBase64 = value;
			},
			async reset() {
				try
				{
					await api.put(`/email/${this.name}/reset`);	
					await this.getData();

					this.showHideBreachDetails(false);
				}
				catch(err) {				
					this.error = err;
				}
			},
			selectAll() {
				this.checkedRows = [];

				for(var breach of this.breaches) {
					this.checkedRows.push(breach.index)
				}
			}
		},
		computed: {
			name() {
				return router.currentRoute.params.name;
			},
			domainName() {
				return this.name.split('@')[1]
			},
			emailName() {
				return this.name.split('@')[0]
			},
			userName() {
				return this.email.userName || '(not set)';
			},
			userStatus() {
				return this.email.userStatus ||'(not set)';
			},
			passwordsWithCount() {
				if (!this.email || !this.email.passwords) return [];

				const results = this.email.passwords.map((password, i) => ({key: i, password:password, count:this.email.counts[i], sources: this.email.sources[i]}));

				//If no excluded passwords, then return
				if (!this.email.excludedPasswordIndexes) return results;

				//Filter out excluded 
				return results.filter((result, i) => this.email.excludedPasswordIndexes.indexOf(i) === -1);			
			},
			emails() {
				if (!this.email || !this.email.emails) return [];
				
				//Get unique emails that are not the primary email
				//Loop through an array of arrays, populating 
				const results = [];
				const exceptions = this.email.excludedEmails;
				
				this.email.emails.forEach(arr => results.push(...arr));
				return results.filter((value, index, self) => value !== this.name && self.indexOf(value) === index && exceptions.indexOf(value) === -1);
			},
			breaches() {
				if (!this.email || !this.email.emails) return [];
				
				const breaches = [];
				const exceptions = this.email.excludedEmails;
				const excludedPasswordIndexes = this.email.excludedPasswordIndexes;
			
				this.email.emails.forEach((arr, index) => {

					//Check for excluded passwords
					if (!excludedPasswordIndexes || excludedPasswordIndexes.indexOf(index) === -1) {

						arr.forEach((item, index2) => {
							
							//check for excluded emails
							if (exceptions.indexOf(item) === -1) {
								
								const sourceResults = this.email.sources[index][index2].split(';');

								let sources = [];
								for (var sourceResult of sourceResults) {
									sources.push(store.getters.getSource(sourceResult));
								}

								//Now we want to get the earliest non combo source
								sources.sort((a,b) => a.date - b.date);

								//We loop through until we have a non combo
								const breachSources = [];
								const comboSources = [];

								for (var source of sources) {
									if (source) {
										if (source.type === 'Breach') {
											breachSources.push(source.rowKey)
										}
										else {
											//Just add first one
											if (!comboSources.length) comboSources.push(source.rowKey)
										}
									}
								}

								breaches.push({
									password: this.email.passwords[index],
									fullPassword: this.email.fullPasswords[index],
									email: item,
									source: (breachSources.length) ? breachSources: comboSources,
									indirect: !(item === this.name),
									index: ((index + 1) * 1000) + index2
								});
							}
						});
					}
				});

				return breaches;
			},
			userStatusDescription() {
				const userStatusDescriptions = {'0':'(not set)', 1:'Enabled', 2:'Disabled', 3:'Expired', 4:'Deleted'};
				return userStatusDescriptions[this.email.userStatus];
			},
			isDomainRoute() {
				return router.currentRoute.name === 'domainEmailDetail' || router.currentRoute.name === 'domainEmailDetailEdit';
			},
			hasReset() {
				return this.email.excludedPasswordIndexes || this.email.excludedEmails.length;
			},
			chartValues() {
				const result = [];
								
				//Loop through each password and total the sources
				let sourceTotals = {};

				//Loop through all breaches
				for (var breach of this.breaches) {
					for (var source of breach.source) {

						if (!source) source='bcomp';
					
						const sourceTotal = sourceTotals[source];

						if (sourceTotal) {
							sourceTotal.additions++;
						}
						else {
							const entity = store.getters.getSource(source);
							
							if (entity) {
								sourceTotals[source] = {
									t:entity.date, 
									additions: 1,
									desc: (entity.name === 'other') ? entity.rowKey : entity.name
								}
							}
						}
					}
				}

				//Create results from sourceTotals
				for (var sourceTotalKey in sourceTotals) {
					const sourceTotal = sourceTotals[sourceTotalKey];

					result.push({
						t:sourceTotal.t, y:0, additions:sourceTotal.additions, customLabel:sourceTotal.desc, customLabelAfter: sourceTotal.additions + ' credentials'
					});
				}
					
				//Sort by date
				result.sort(function(a,b){
					// Turn your strings into dates, and then subtract them
					// to get a value that is either negative, positive, or zero.
					return new Date(a.t) - new Date(b.t);
				});

				//Finally, loop through the results and add each value together
				let total =0;
				for (var item of result) {
					total+=item.additions;
					item.y=total;
				}

				//Add a fake result to make the graph more readable if there is only one value
				if (result.length === 1) {
					const firstItem = result[0],
							newDate = new Date(firstItem.t.getTime());
					
					newDate.setFullYear( newDate.getFullYear() - 1 );

					result.unshift({
						t:newDate, y:0, additions:0, customLabel:'', customLabelAfter: ''
					});
				}
		
				return result;
			}
		},	
		mounted() {
			this.getData();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/EmailDetailPanel.vue